import { inject as service } from '@ember/service';
import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';

export default Route.extend({
  theme: Theme.PAGE,

  router: service(),

  redirect(model, transition) {
    const modelAppPage = model.appPage;

    if (!modelAppPage || !modelAppPage.page || !modelAppPage.page.name) return;

    if (modelAppPage.page.isOwnerAdmin) {
      this._super();
    } else if (transition.targetName !== 'app.publicid.settings.permissions') {
      this.router.transitionTo('app.publicid.settings.permissions');
    }
  },

  model() {
    return {
      appPage: this.modelFor('app.publicid'),
    };
  },
});
